export default __webpack_public_path__ + "8ca81aef2eebf494c051fff7990b3f0e.png";